import { Switch, Tag, Select } from 'antd';
import { TFieldRendererProps } from '@/types/TSmartCRM';
import { EFieldMode } from 'src/enums/ESmartCRM';

const { Option } = Select;

export const BooleanRenderer = ({
	value,
	onChange,
	mode,
	disabled = false,
}: TFieldRendererProps) => {
	const boolValue = Boolean(value);

	if (mode === EFieldMode.DISPLAY) {
		return <Tag color={boolValue ? 'green' : 'default'}>{boolValue ? 'Yes' : 'No'}</Tag>;
	}

	if (mode === EFieldMode.FILTER) {
		return (
			<Select
				value={value === null || value === undefined ? undefined : boolValue}
				onChange={onChange}
				disabled={disabled}
				placeholder="Select option"
				allowClear
			>
				<Option value={true}>Yes</Option>
				<Option value={false}>No</Option>
			</Select>
		);
	}

	return <Switch checked={boolValue} onChange={onChange} disabled={disabled} />;
};
